<template>
  <div class="menu-wrapper-container"
       :class="{'active-menu' : activeMenu}">
    <icon-default :is-active-hover="true"
                  :class="{'disabled' : pinMenu}"
                  @click="changeStateMenu"
                  :color="activeMenu ? 'dark-green-light' : 'default'">
      <menu-icon/>
    </icon-default>
    <div class="menu-item-content">
      <router-link v-for="item in navigationInfo"
                   @mouseenter="focusId = item.id"
                   @mouseleave="focusId = -1"
                   :class="['title-icon-container',
                      { 'active': returnActive(item.name, item.id)}
                     ]"
                   :key="item.id"
                   :to=" { name: item.name } ">

        <icon-default :color="returnActive(item.name, item.id)
            ? 'dark-green'
            : 'dark-green-light'">
          <component :is="item.icon"/>
        </icon-default>
        <main-title>
          {{ item.text }}
        </main-title>
      </router-link>
      <div
          @click="logout()"
          @mouseenter="focusId = 7"
          @mouseleave="focusId = -1"
          :class="['title-icon-container',
                      { 'active': returnActive('exit', 7)}
                     ]">
        <icon-default :color="returnActive('exit', 7)
            ? 'dark-green'
            : 'dark-green-light'">
          <component :is="exitInfo.icon"/>
        </icon-default>
        <main-title>
          {{ exitInfo.text }}
        </main-title>
      </div>
    </div>
  </div>
</template>

<script>
import IconDefault from "@/components/shared/icons/IconDefault.vue";

import menuIcon from '@/assets/icons/menu/menu.svg?inline'
import exitIcon from '@/assets/icons/menu/exit.svg?inline'
import MainTitle from "@/components/shared/text/MainTitle.vue";


export default {
  name: "MainMenu",
  components: {
    MainTitle,IconDefault,
    exitIcon,
    menuIcon},
  data() {
    return {
      activeMenu: true,
      pinMenu: false,
      focusId: -1,
    }
  },
  methods: {
    returnActive(name, id) {
      return this.activeRout === name || id === this.focusId
    },
    changeStateMenu() {
      this.activeMenu = !this.activeMenu
    },
    changeAction(item) {
      switch (item.name) {
        case 'logout':
          this.logout();
          break;
      }
    }
  },
  computed: {
    activeRout() {
      return this.$route.name;
    },
    exitInfo() {
      return {
        text: 'Выйти',
        icon: exitIcon
      }
    }
  },
}
</script>

<style scoped lang="scss">
.menu-wrapper-container {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 32px;
  width: 88px;
  transition: all .3s ease;
  overflow: hidden;
  background: rgba(var(--color-grey-rgba), 0.2);

  .icon-container {
    cursor: pointer;
  }

  &.active-menu {
    width: 245px;

    .menu-item-content {
      .title-icon-container {
        .main-title-container {
          opacity: 0.6;
        }
        &.active{
          .main-title-container {
            opacity: 1;
          }
        }
      }
    }
  }

  .menu-item-content {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    height: 100%;

    .title-icon-container {
      cursor: pointer;
      white-space: nowrap;
      display: flex;
      flex-direction: row;
      align-items: center;
      column-gap: 16px;

      &:nth-last-child(2) {
        margin-top: auto;
      }

      .main-title-container {
        position: relative;
        opacity: 0;
        transition: all .3s ease;
        color: var(--color-dark-green);

        &:before {
          content: '';
          width: 100%;
          height: 1px;
          background-color: var(--color-dark-green);
          position: absolute;
          left: 0;
          bottom: 0;
          transform: scaleX(0);
          transform-origin: right;
          transition: transform 0.25s;
        }
      }

      &.active {
        .main-title-container {
          color: var(--color-dark-green);
          &:before {
            transform: scaleX(1);
            transform-origin: left;
            transition: transform 0.25s;
          }
        }

      }
    }

  }
}
</style>